var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospital = function SvgHospital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 28.333c7.364 0 13.333-5.97 13.333-13.333S22.363 1.667 15 1.667 1.667 7.637 1.667 15 7.637 28.333 15 28.333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.444 8.733c0-.373 0-.56-.072-.702a.67.67 0 0 0-.292-.292c-.142-.072-.329-.072-.702-.072h-2.756c-.373 0-.56 0-.702.072a.67.67 0 0 0-.292.292c-.072.142-.072.329-.072.702v2.756c0 .373 0 .56-.073.702a.67.67 0 0 1-.292.292c-.142.073-.329.073-.702.073H8.733c-.373 0-.56 0-.702.072a.67.67 0 0 0-.292.292c-.072.142-.072.329-.072.702v2.756c0 .373 0 .56.072.702a.67.67 0 0 0 .292.292c.142.072.329.072.702.072h2.756c.373 0 .56 0 .702.073a.67.67 0 0 1 .292.291c.073.143.073.33.073.703v2.756c0 .373 0 .56.072.702a.67.67 0 0 0 .292.292c.142.072.329.072.702.072h2.756c.373 0 .56 0 .702-.072a.67.67 0 0 0 .292-.292c.072-.142.072-.329.072-.702V18.51c0-.373 0-.56.073-.703a.67.67 0 0 1 .291-.29c.143-.074.33-.074.703-.074h2.756c.373 0 .56 0 .702-.072a.67.67 0 0 0 .292-.292c.072-.142.072-.329.072-.702v-2.756c0-.373 0-.56-.072-.702a.67.67 0 0 0-.292-.292c-.142-.072-.329-.072-.702-.072H18.51c-.373 0-.56 0-.703-.073a.67.67 0 0 1-.29-.292c-.074-.142-.074-.329-.074-.702z"
  })));
};
export default SvgHospital;